import React, { useMemo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import QRCode from 'qrcode'

function getCssVar (name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim()
}

export function QrCodeSvg ({ value }) {
  const [svg, setSvg] = useState(null)

  const opts = useMemo(() => {
    return {
      type: 'svg',
      margin: 2,
      errorCorrectionLevel: 'M',
      color: {
        dark: getCssVar('--primary'),
        light: getCssVar('--light'),
      },
    }
  }, [])

  useEffect(() => {
    let cancelled = false

    QRCode.toString(value, opts)
      .then((svgString) => {
        if (!cancelled) setSvg(svgString)
      })

    return () => { cancelled = true }
  }, [value, opts])

  if (!svg) {
    return <div style={{ height: 180 }} />
  }

  return (
    <div className='qrcode' dangerouslySetInnerHTML={{ __html: svg }} />
  )
}

QrCodeSvg.propTypes = {
  value: PropTypes.string.isRequired,
}
